export enum FeedTypes {
  SHARED_REFLECTIONS = "REFLECTION_FEED",
  ANNOUNCEMENT_FEED = "ANNOUNCEMENT_FEED",
  QUESTION = "QUESTION_FEED",
  DISCUSSION = "DISCUSSION_FEED",
  PERSONAL = "PERSONAL_REFLECTION_FEED",
  TASK = "TASK_FEED",
  PUBLIC = "PUBLIC_FEED"
}
